import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import notFoundImg from '../../assets/images/notFound.svg';

export const NotFound = () => {
  const [timer, setTimer] = useState(5);
  const history = useHistory();

  useEffect(() => {
    setInterval(() => {
      setTimer(current => current - 1);
    }, 1000);
  }, []);

  useEffect(() => {
    if (timer === 0) {
      history.push('/');
    }
  }, [timer]);

  return (
    <>
      <div className="flex items-center h-screen justify-center flex-col bg-tertiary ">
        <img
          className="h-56 md:h-72 lg:h-96"
          src={notFoundImg}
          alt="not found"
        />
        <h1 className="text-4xl text-secondary">Page not found</h1>
        <p className="mt-12 text-secondary">redirecionamento em {timer}</p>
      </div>
    </>
  );
};
